import React from 'react';
import './Footer.scss';

const Footer = () => <div className='Footer'>I'm the footer!!</div>;

export default Footer;
